/* eslint-disable  */
import React, { useState, useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactPlayer from 'react-player';
import clsx from 'clsx';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import styles from './Post.module.scss';

function Video({
  src,
  poster,
  isActiveSlide = false,
  className,
  targetPostId, // unused
  id, // unused
}: {
  src?: string;
  poster?: string;
  isActiveSlide: boolean;
  isNextSlide?: boolean;
  isPrevSlide?: boolean;
  progressHovered?: boolean;
  onProgressHover?: (state: boolean) => void;
  handleVideoMuted?: (state: boolean) => void;
  className?: string;
  isActiveCaptions?: boolean;
  id?: string;
  targetPostId?: string;
}) {
  const [playing, setPlaying] = useState(isActiveSlide);
  
  const { isSoundOn } = useTypedSelector(state => state.postSlice);
  const { setIsSoundOn } = useActions();
  
  const playerRef = useRef<ReactPlayer>(null);
  const VIDEO_CONFIG = 'q_auto,f_auto';

  // Sync internal playing state with slide activity
  useEffect(() => {
    if (isActiveSlide) {
      setPlaying(true);
      // Reset video to start when appearing on screen
      playerRef.current?.seekTo(0, 'seconds');
    } else {
      setPlaying(false);
    }
  }, [isActiveSlide]);

  const handlePlayPause = (e) => {
    e.stopPropagation();
    // If Global Sound is OFF, interacting should mainly Turn It ON.
    if (!isSoundOn) {
      setIsSoundOn(true);
      setPlaying(true); // Ensure it plays
    } else {
      // If Global Sound is ON, then it acts as a Play/Pause toggle
      setPlaying(!playing);
    }
  };

  return (
    <div
      id="videoContainer"
      className={clsx(styles.videoContainer, className)}
      onClick={handlePlayPause}
    >
      <ReactPlayer
        ref={playerRef}
        url={
          // Preserve Cloudflare Stream and HLS URLs
          src?.includes('cloudflarestream.com') || src?.includes('.m3u8')
            ? src
            // Preserve Cloudinary URLs that already have transformation suffixes (e.g., _720w_nolylx, _1080p)
            : src?.match(/_\d+[wp](_|\.)/i)
            ? src
            // Apply VIDEO_CONFIG to Cloudinary uploads without transformations
            : src?.includes('cloudinary.com') && src?.includes('/upload/')
            ? src?.replace(/\.\w+$/, '.mp4').replace('upload', `upload/${VIDEO_CONFIG}`)
            // For non-Cloudinary URLs (like Supabase), use as-is
            : src
        }
        playing={playing}
        loop
        width="100vw"
        height="100vh"
        // Muted depends only on GLOBAL state
        muted={!isSoundOn}
        config={{
          file: {
            attributes: {
              autoPlay: isActiveSlide, // Only active video should have autoPlay
              playsInline: true,
              'webkit-playsinline': 'true',
            },
          },
        }}
        controls={false}
        // Handlers
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onReady={() => {
          if (isActiveSlide) setPlaying(true);
        }}
        preload="auto"
      />
      <div className={styles.containerInfoBg} />
    </div>
  );
}

export default Video;